import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { TransfersService } from '@core/services/transfers.service';
import { ValidationsService } from '@core/services/validations.service';
import { Constants } from '@shared/class/constants.class';
import { Transfer } from '@shared/interfaces/transfer';
import { PhonePipe } from '@shared/pipes/phone.pipe';

@Component({
  selector: 'app-transfers-edit',
  templateUrl: './transfers-edit.component.html'
})
export class TransfersEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();
  public constants2 = new Constants();

  public transfer: Transfer;
  public transfersList: Array<Transfer> = [];
  public transferForm: FormGroup;
  public customerData = false;
  public subtitle = '';
  public rol = '';
  public cellOrIdentify = 0;

  public displayEditTel = false;
  public displayEditDoc = false;

  public location = 'transfersReference';
  public actions: Array<string> = [
    this.appConfig.ACTIONS.edit.id,
    this.appConfig.ACTIONS.editId.id
  ];

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private transfersService: TransfersService,
    public dialogRef: MatDialogRef<TransfersEditComponent>,
    public phonePine: PhonePipe,
    @Inject(MAT_DIALOG_DATA) public data
  ) {

    const result = this.generalsService.getActions(
      [],
      this.actions,
      this.location
    );
    this.constants2.displayedActions = result.displayedActions;
  }

  ngOnInit() {
    this.constants.title =
      this.appConfig.LANG.title.edit +
      ' ' +
      this.appConfig.LANG.transfers.title;
    this.transfer = this.data;
    if (this.constants2.displayedActions.edit) {
      this.displayEditTel =  true;
    }
    if (this.constants2.displayedActions.editId) {
      this.displayEditDoc = true;
    }
    this.transferForm = new FormGroup({
      reference: new FormControl(this.transfer.reference, Validators.required),
      rol: new FormControl('', Validators.required),
      editOptions: new FormControl(''),
      customer: new FormControl(
        { value: '', disabled: true },
        Validators.required
      ),
      cellOld: new FormControl(
        { value: '', disabled: true },
        Validators.required
      ),
      cell: new FormControl('', [
        Validators.required,
        Validators.maxLength(10),
        ValidationsService.isInvalidNumberValidator,
        ValidationsService.isInvalidCellValidator
      ]),
      identifyOld: new FormControl(
        { value: '', disabled: true },
        Validators.required
      ),
      identify: new FormControl('', [
        Validators.required,
        Validators.maxLength(10),
        ValidationsService.isInvalidNumberValidator
      ])
    });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.transferForm;
    if (form.dirty && form.valid) {
      let message = '';
      if (this.cellOrIdentify === this.appConfig.EDIT_OPTIONS.cell) {
        message = this.appConfig.LANG.transfers.editCell;
        message = message.replace(
          '{CELL}',
          this.phonePine.transform(form.controls['cell'].value)
        );
        message = message.replace('{CUSTOMER}', this.rol);
        this.generalsService.save(
          'edit',
          form,
          this.dialogRef,
          this.transfersService,
          message
        );

      } else if (this.cellOrIdentify === this.appConfig.EDIT_OPTIONS.identify) {
        message = this.appConfig.LANG.transfers.editIdentify;
        message = message.replace(
          '{IDENTIFY}', form.controls['identify'].value
        );
        message = message.replace('{CUSTOMER}', this.rol);
        this.generalsService.save(
          'editId',
          form,
          this.dialogRef,
          this.transfersService,
          message
        );
      }
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }

  changeEditOption(event: any){
    const controlEditoption = this.transferForm.controls['editOptions'];
    const controlRol = this.transferForm.controls['rol'];
    controlEditoption.clearValidators();
    this.transferForm.patchValue({
      identify: null,
      cell: null
    });
    this.cellOrIdentify = +event.value;
    controlRol.reset();
    this.changeRol(event);
  }

  changeRol(event: any) {
    const controlRol = this.transferForm.controls['rol'];
    const controlEditOptions = this.transferForm.controls['editOptions'];
    controlRol.clearValidators();
    controlEditOptions.clearValidators();
    let tempIndetify;
    let tempCell;

    if (event.value === this.appConfig.OWNER) {

      if (this.cellOrIdentify === this.appConfig.EDIT_OPTIONS.cell) {
        tempIndetify = this.transfer.identifyOwner;
      } else if (this.cellOrIdentify === this.appConfig.EDIT_OPTIONS.identify) {
        tempCell = this.transfer.cellOwner;
      }
      this.subtitle = this.appConfig.LANG.transfers.titleOwner;
      this.rol = this.appConfig.LANG.transfers.owner;
      this.transferForm.patchValue({
        customer: this.transfer.nameOwner,
        cellOld: this.transfer.cellOwner,
        identifyOld: this.transfer.identifyOwner,
        identify: tempIndetify,
        cell: tempCell
      });
      this.customerData = true;
    } else if (event.value === this.appConfig.BENEFICIARY) {

      if (this.cellOrIdentify === this.appConfig.EDIT_OPTIONS.cell) {
        tempIndetify = this.transfer.identifyBeneficiary;
      } else if (this.cellOrIdentify === this.appConfig.EDIT_OPTIONS.identify) {
        tempCell = this.transfer.cellBeneficiary;
      }

      this.subtitle = this.appConfig.LANG.transfers.titleBeneficiary;
      this.rol = this.appConfig.LANG.transfers.beneficiary;
      this.transferForm.patchValue({
        customer: this.transfer.nameBeneficiary,
        cellOld: this.transfer.cellBeneficiary,
        identifyOld: this.transfer.identifyBeneficiary,
        identify: tempIndetify,
        cell: tempCell
      });
      this.customerData = true;
    } else {
      this.customerData = false;
    }

    controlRol.updateValueAndValidity();
    controlEditOptions.updateValueAndValidity();
  }
  
}
